import { BrandGroupID } from "./Brand";
import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";

export type FactoryExportID = number;

export type FactoryExportReceiverID = number;

export enum FACTORYEXPORT_FREQUENCY {
  EveryWeek = 1,
  EveryTwoWeeks = 2,
  EveryMonth = 3,
  EveryDay = 4
}

export enum FACTORYEXPORT_QUERYRANGE {
  OneDay = 1,
  OneWeek = 2,
  TwoWeeks = 3,
  OneMonth = 4,
  TwoMonths = 5,
  ThreeMonths = 6,
  SixMonths = 7,
  OneYear = 8,
  TwoYears = 9,
  ThreeYears = 10
}

export enum FACTORY_REPORTS {
  LocationOverview = 1,
  TyreOverview = 2,
  EmployeeOverview = 3,
  CommunicationsOverview = 4,
  MGMaintenance = 5,
  KIADealerChecks = 6,
  JaguarAppointmentOverview = 7,
  LandroverAppointmentOverview = 8,
  DeskcheckInOverviewPerEmployee = 9,
  PinnedAppointmentsLocationOverview = 10,
  AppointmentStatusOverview = 11,
  StellantisNL = 12,
  LocationAndCommunicationOverview = 13,
  RecurringCars = 14,
  LocationOverviewV8 = 15,
  LocationAndCommunicationOverviewV8 = 16,
  JaguarAppointmentOverviewV8 = 17,
  LandroverAppointmentOverviewV8 = 18,
  ChecklistReport = 19,
  OnlineCheckInServices = 20
}

export enum FACTORYEXPORT_RECEIVERSTATUS {
  Pending = 1,
  Success = 2,
  Failed = 3
}

export interface FactoryReport {
  created_on: string;
  updated_on: string;
  id: FACTORY_REPORTS;
  name: string; // Name of this FactoryReport
  file_name: string; // Which file this FactoryReport is linked to
}

export interface FactoryExport {
  created_on: string;
  updated_on: string;
  id: FactoryExportID;
  name: string; // Name given to this FactoryExport
  factory_report_id: FACTORY_REPORTS; // Identifier of the FactoryReport which denotes the type of data to retrieve
  emails: string; // Email addresses to send this FactoryExport to
  email_subject: string; // Subject of the email
  email_message: string; // Message body of the email
  query_range: FACTORYEXPORT_QUERYRANGE; // Range of the data to query for when sending this FactoryExport
  frequency: FACTORYEXPORT_FREQUENCY; // Frequency to send this FactoryExport
  day: number; // Day of the month to send this FactoryExport
  is_ods_format: boolean; // This FactoryExport is sent as an ODS filetype instead of CSV
  is_ams_timezone: boolean; // Timestamps in the export are in AMS timezone
  dealer_ids?: DealerID[];
  dealer_location_ids?: DealerLocationID[];
  factory_report_name?: string;
  factory_report_file_name?: string;
  brand_group_ids?: BrandGroupID[];
}

export interface FactoryExportReceiver {
  created_on: string;
  updated_on: string;
  id: FactoryExportReceiverID;
  factory_export_id: FactoryExportID; // Identifier of the FactoryExport this receiver was for
  factory_report_id: FACTORY_REPORTS; // Identifier of the FactoryReport for the data that was received
  query_range: FACTORYEXPORT_QUERYRANGE; // Query range of the FactoryExport at the time of this receiver
  frequency: FACTORYEXPORT_FREQUENCY; // Frequency of the FactoryExport at the time of this receiver
  day: number; // Day of the FactoryExport at the time of this receiver
  email: string; // The email address of the receiver
  status: FACTORYEXPORT_RECEIVERSTATUS; // Status of sending the data to the receiver
  reason: string; // Reason it failed to send to the receiver
  mailgun_message_id: string; // MailgunMessageID uses to send to the receiver and check its status
}
